import { Environment } from 'src/environments/environment.interfaces';
import { sharedConfig } from 'src/environments/environment.shared';

export const environment: Environment = {
	...sharedConfig,
	production: false,
	appSyncRegion: 'eu-north-1',
	abstractionLayerStagingUrl: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
	abstractionLayerReleaseUrl: 'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerStagingUrl: 'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerReleaseUrl: 'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql',
	logConfig: {
		application: 'chimera',
		env: 'dev',
		graphqlUrl: 'https://kftht5tfp5b6tfwm6kzqa7ijzu.appsync-api.eu-north-1.amazonaws.com/graphql',
		logLevel: 2,
		console: true,
		debounceTime: 5000,
	},
	redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login',
	homeUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com',
	serviceWorkerEnabled: true,
	analyticsAppId: 'chimera',
	analyticsSdkScriptUrl: 'https://webanalytics-sdk.testtools.devtest.gf.aws.scania.com/analytics.sdk.js',
};
